import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from './ProductCard';

const ProductCardGroup = props => {
  const renderCard = (key, product) => {
    return (
      <ProductCard
        key={key}
        productId={key}
        onClickActionBtn={props.onClickActionBtn}
        banner={props.banner}
        model={product}
      />
    );
  };

  return (
    <div className="card-group">
      <div className="card-group-scrollable">
        {Object.keys(props.products).map(key => renderCard(key, props.products[key]))}
      </div>
    </div>
  );
};

ProductCardGroup.propTypes = {
  products: PropTypes.object.isRequired,
  banner: PropTypes.string,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductCardGroup;
